import React, { Component } from "react";
import { Row, Col, Form, Space, Button, Select, Input, message } from "antd";
import { Link } from "react-router-dom";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import AssignVehicleToCompanyStore from "../store/AssignVehicleToCompanyStore";

class AssignVehicleToCompany extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.assignVehicleToCompany = new AssignVehicleToCompanyStore();
    this.formRef = React.createRef();
    this.state = {
      loadList: 0,
      companyId: "",
      assigncompanyId: "",
      vehicleOptions: [],
    };
  }
  async handleChange(comp) {
    console.log(comp.value);
    await this.setState({ companyId: comp.value });
    // await this.formRef.current.setFieldsValue({ companyId: this.state.companyId })
    const data = await this.assignVehicleToCompany.getAssetData({
      companyId: comp.value,
    });
    console.log(data, "data");
    const vehicleOptions = await data.map((item) => ({
      label: item.vehicleNo,
      value: item.vehicleId,
    }));
    this.setState({ vehicleOptions }, () => {
      console.log("Vehicle options set:", this.state.vehicleOptions);
    });

    await this.setState({ loadList: 1 });

    // await this.handleSearch()
  }
  async handleCompanyChange(comp) {
    console.log(comp.value);
    await this.setState({ assigncompanyId: comp.value });
    // await this.formRef.current.setFieldsValue({ companyId: this.state.companyId })
    // const data = await this.assignVehicleToCompany.getAssetData({companyId:comp.value})
    // console.log(data,"data")

    await this.setState({ loadList: 1 });

    // await this.handleSearch()
  }

  // async handleSearch() {
  //   this.setState({loading:true})
  //   await this.assignVehicleToCompany.loadData({
  //     assigncompanyId:this.state.companyId,
  //     vehicleIds:this.state.selectedVehicles,
  //     companyId: this.state.companyId,
  //   });
  //   await this.setState({ loadData: 1 });
  // }

  onAssignVehicleToCompany = async (values) => {
    // console.log(values);
    const data = {
      ...values,
      companyId: this.state.companyId,
      assigncompanyId: this.state.assigncompanyId,
    };
    console.log(data);
    const response = await this.assignVehicleToCompany.addData(data);
    console.log(response);
    if (response.data.success === "S") {
      message.success("Vehicle successfully assigned to company");
      console.log(response);
    } else {
      message.error(response.data.message);
    }
    if (response.data.message) {
      // this.formRef.current?.resetFields();
      this.closeModal();
    }
  };

  vehicleSelect = async (val) => {
    console.log(val);
    await this.setState({ selectedVehicles: val });
  };
  closeModal = () => {
    this.props.closeModalAssign();
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Form
            style={{ maxWidth: "100%" }}
            ref={this.formRef}
            layout="vertical"
            onFinish={this.onAssignVehicleToCompany}
            {...this.layout}
            name="nest-message"
            className="formClass"
          >
            {/* <Row className="headerFixed"> */}
            {/* <Col span={12}>
              <div className="heading">Assign Vehicle To Company</div>
            </Col> */}

            {/* <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            > */}
            {/* <Space style={{}}>
              <Link to={"/vehiclelist"}><Button ghost type="primary">
                  {" "}
                 Back{" "}
                </Button></Link>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
                <Button
                  ghost
                  danger
                  type="primary"
                  htmlType=""
                  onClick={(e) => {
                    this.formRef.current?.resetFields();
                  }}
                >
                  Cancel
                </Button>
              </Space> */}
            {/* </Col>
          </Row> */}
            <Row className="overflowFormInputs">
              <Col span={24} className="formColumnClass">
                <Form.Item
                  name="companyId"
                  className="uploadCompany"
                  label={
                    <span>
                      {this.context.translate("_ACCOUNT_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_ACCOUNT_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                >
                  <CompanyAutocomplete
                    onChange={(value) => {
                      this.handleChange(value);
                    }}
                    // style={{ width: 400 }}
                  />
                </Form.Item>

                <Form.Item
                  name="vehicleIds"
                  // label="Asset Name"
                  // label={this.context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_")}
                  label={
                    <span>
                      {this.context.translate("_ASSET_NUMBER_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_ASSET_NUMBER_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                  className="uploadCompany"
                >
                  <Select
                    mode="multiple"
                    maxTagCount="responsive"
                    onChange={(val) => this.vehicleSelect(val)}
                    name="vehicleIds"
                    // fieldNames={{ label: "vehicleNo", value: "vehicleId" }}
                    placeholder={this.context.translate("_ASSET_NUMBER_")}
                    // optionFilterProp="children"
                    // options={this.assignVehicleToCompany?.getVehiclesUsingCompanyId}
                    options={this.state.vehicleOptions}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="assigncompanyId"
                  label={
                    <span>
                      {this.context.translate("_ASSIGN_VEHICLE_TO_COMPANY_")}{" "}
                      <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: `${this.context.translate(
                        "_ASSIGN_VEHICLE_TO_COMPANY_"
                      )} ${this.context.translate("_IS_REQUIRED_")}`,
                    },
                  ]}
                  className="uploadCompany"

                  // label="Assign Vehicle To Company"
                  // label={this.context.translate("_ASSIGN_VEHICLE_TO_COMPANY_")}
                >
                  <CompanyAutocomplete
                    onChange={(value) => {
                      this.handleCompanyChange(value);
                    }}
                    // style={{ width: 400 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="formFooter">
              <Button
                className="formsCancelButton"
                onClick={() => this.closeModal()}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>

              <Button htmlType="submit" className="formsSaveButton">
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

AssignVehicleToCompany.contextType = StoreContext;
export default observer(withRouter(AssignVehicleToCompany));
